'use es6';

import Immutable from 'immutable';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
const EMPTY_MAP = Immutable.Map();
const EMPTY_SET = Immutable.Set();
const initialMoreAppsState = new Immutable.Map({
  hasCategoryResults: false,
  results: new Immutable.OrderedSet()
});
const initialCompatibilityState = {
  compatibility: EMPTY_MAP,
  portalTiers: EMPTY_SET
};
const initialState = Immutable.fromJS({
  compatibility: initialCompatibilityState,
  listingViewsCache: EMPTY_MAP,
  listingViewsFetchErrorCache: EMPTY_MAP,
  listingViewsFetchStatusCache: EMPTY_MAP,
  moreApps: initialMoreAppsState,
  reviewabilityFetchStatusCache: EMPTY_MAP,
  referrer: null
});

const details = (state = initialState, {
  type,
  payload,
  meta
}) => {
  switch (type) {
    case ActionTypes.DETAILS_FETCH_REQUESTED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsFetchStatusCache', slug], RequestState.PENDING).deleteIn(['listingViewsFetchErrorCache', slug]));
      }

    case ActionTypes.DETAILS_FETCH_RECEIVED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsCache', slug], payload).setIn(['listingViewsFetchStatusCache', slug], RequestState.SUCCEEDED));
      }

    case ActionTypes.DETAILS_FETCH_FAILED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsFetchErrorCache', slug], payload).setIn(['listingViewsFetchStatusCache', slug], RequestState.FAILED));
      }

    case ActionTypes.FEATURE_COMPATIBILITY_RECEIVED:
      return state.set('compatibility', payload);

    case ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED:
      return state.set('moreApps', payload);

    case ActionTypes.DETAILS_MORE_APPS_RESET:
      return state.set('moreApps', initialMoreAppsState);

    case ActionTypes.DETAILS_REVIEWABILITY_REQUESTED:
      return state.setIn(['reviewabilityFetchStatusCache', meta.slug], RequestState.PENDING);

    case ActionTypes.DETAILS_REVIEWABILITY_RECEIVED:
      return state.withMutations(mutableState => {
        const {
          slug
        } = meta;
        const currentListing = mutableState.getIn(['listingViewsCache', slug]);
        return mutableState.setIn(['reviewabilityFetchStatusCache', slug], RequestState.SUCCEEDED).setIn(['listingViewsCache', slug], currentListing.setReviewability(payload));
      });

    case ActionTypes.DETAILS_REVIEWABILITY_FAILED:
      return state.setIn(['reviewabilityFetchStatusCache', meta.slug], RequestState.FAILED);

    case ActionTypes.NEW_REVIEW_SUBMITTED_SUCCESS:
      {
        const {
          slug
        } = meta;
        return state.setIn(['listingViewsCache', slug, 'reviewability', 'userAlreadyReviewed'], true);
      }

    case ActionTypes.DETAILS_REFERRER_SET:
      {
        return state.set('referrer', payload);
      }

    case ActionTypes.DETAILS_REFERRER_RESET:
      {
        return state.set('referrer', null);
      }

    default:
      return state;
  }
};

export default details;